import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/ko-validation');

const keywordBidRange = config.get('KeywordBidRange') || {
  //the default value is refered from UI server which is actually from MT
  CeilingValue: 1000,
  FloorValue: 0,
};

const productGroupBidRange = config.get('ProductGroupBidRange') || {
  //the default value is refered from UI server which is actually from MT
  CeilingValue: 1000,
  FloorValue: 0.01,
};

const windowsStoreAdsBidRange = config.get('WindowsStoreAdsBidRange') || {
  CeilingValue: 1000,
  FloorValue: 1,
};

export default {
  extend(viewModel, propertyNames, useProductGroupBidRange = false, isMSStoreCampaign = false) {
    _.each(propertyNames, (property) => {
      const enumValidator = _.result(viewModel[property].validators, 'range');

      if (enumValidator) {
        let bidRange = useProductGroupBidRange ? productGroupBidRange : keywordBidRange;

        if (isMSStoreCampaign) {
          bidRange = windowsStoreAdsBidRange;
        }
        const min = bidRange.FloorValue;
        const max = bidRange.CeilingValue;

        enumValidator.min = min;
        enumValidator.max = max;
        enumValidator.message = i18n.get('Validation_Number_Range_Between', {min, max});
      }
    });
  },
};
